// extracted by mini-css-extract-plugin
export var bottomFade = "hero-module--bottom-fade--b57b8";
export var fade = "hero-module--fade--eb5d9";
export var hero = "hero-module--hero--c42c6";
export var heroArrowUpIcon = "hero-module--hero-arrow-up-icon--6ae41";
export var heroButton = "hero-module--hero-button--df43d";
export var heroH1 = "hero-module--hero-h1--47b88";
export var heroImage = "hero-module--hero-image--64a55";
export var heroPara = "hero-module--hero-para--96b1b";
export var leftFade = "hero-module--left-fade--64baa";
export var rightFade = "hero-module--right-fade--f1f1c";
export var role = "hero-module--role--59a7d";
export var topFade = "hero-module--top-fade--4af5b";